export default async function getMyUserId(): Promise<string | null> {
  return null;
}
